export const VALIDATED_PAYEE_FIELD_MAX_LENGTH = {
  duns: 9,
};
